import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner
} from 'reactstrap';
import classnames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import api, { FILE_BASE_URL } from '../../utils/api';

import axios from 'axios';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";

const ViewInstitution = (props) => {
  const { id } = useParams();
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('1');
  const [images, setImages] = useState([]);
  const [responsibleData, setResponsibleData] = useState(null); // 🆕 بيانات المسؤول
  const [linkedJournalists, setLinkedJournalists] = useState([]); // 🆕 الصحفيين المرتبطين
  const [linkedActivists, setLinkedActivists] = useState([]); // 🆕 الناشطين المرتبطين
  const [linkedInstitutionPeers, setLinkedInstitutionPeers] = useState([]); // 🔗 المؤسسات الأخرى المرتبطة
  const [linkedDataLoading, setLinkedDataLoading] = useState(false); // 🆕 تحميل بيانات الارتباطات
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageZoomed, setImageZoomed] = useState(false);

  // دالة لإنشاء الدائرة الملونة للصحفيين
  const getJournalistAvatarCircle = (name, size = '50px', fontSize = '16px') => {
    const firstLetter = name ? name.charAt(0).toUpperCase() : 'ص';
    
    return (
      <div 
        className="rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{
          backgroundColor: '#34c38f', // أخضر للصحفيين
          color: '#ffffff',
          fontSize: fontSize,
          fontWeight: 'bold',
          width: size,
          height: size,
          minWidth: size,
          minHeight: size
        }}
      >
        {firstLetter}
      </div>
    );
  };

  // دالة لإنشاء الدائرة الملونة للناشطين
  const getActivistAvatarCircle = (name, size = '50px', fontSize = '16px') => {
    const firstLetter = name ? name.charAt(0).toUpperCase() : 'ن';
    
    return (
      <div 
        className="rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{
          backgroundColor: '#f46a6a', // أحمر للناشطين
          color: '#ffffff',
          fontSize: fontSize,
          fontWeight: 'bold',
          width: size,
          height: size,
          minWidth: size,
          minHeight: size
        }}
      >
        {firstLetter}
      </div>
    );
  };

  // 🔗 دالة لإنشاء الدائرة الملونة للمؤسسات الأخرى المرتبطة
  const getInstitutionPeerAvatarCircle = (name, size = '50px', fontSize = '16px') => {
    const firstLetter = name ? name.charAt(0).toUpperCase() : 'م';

    return (
      <div
        className="rounded-circle d-inline-flex align-items-center justify-content-center"
        style={{
          backgroundColor: '#556ee6', // أزرق للمؤسسات
          color: '#ffffff',
          fontSize: fontSize,
          fontWeight: 'bold',
          width: size,
          height: size,
          minWidth: size,
          minHeight: size
        }}
      >
        {firstLetter}
      </div>
    );
  };

  useEffect(() => {
    props.setBreadcrumbItems('عرض المؤسسة', [
      { title: "الرئيسية", link: "/dashboard" },
      { title: "المؤسسات", link: "/dashboard/institutions" },
      { title: "عرض المؤسسة", link: "#" }
    ]);
    fetchInstitution();
  }, []);

  const fetchInstitution = async () => {
    try {
     const response = await api.get(`/institutions/${id}`);

      if (response.data && response.data.data) {
        const institutionData = response.data.data;
        setInstitution(institutionData);

        // تحميل الصور
        if (institutionData.images) {
          try {
            const parsedImages = JSON.parse(institutionData.images);
            setImages(parsedImages);
          } catch (e) {
            console.error("فشل في قراءة الصور:", e);
            setImages([]);
          }
        }

        // 🆕 تحميل بيانات المسؤول حسب النوع
        await fetchResponsibleData(institutionData);
      }
    } catch (error) {
      console.error('خطأ في جلب بيانات المؤسسة:', error);
    } finally {
      setLoading(false);
    }
  };

  // 🆕 دالة جلب بيانات المسؤول
  const fetchResponsibleData = async (institutionData) => {
    try {
      const token = localStorage.getItem('auth_token');
      let responsibleInfo = null;

      switch (institutionData.responsible_type) {
      case 'existing_journalist':
         if (institutionData.responsible_journalist_id) {
           const journalistRes = await api.get(`/journalists/${institutionData.responsible_journalist_id}`);
           responsibleInfo = {
             type: 'journalist',
             data: journalistRes.data.data,
             title: 'صحفي مسؤول'
           };
         }
         break;

       case 'existing_activist':
         if (institutionData.responsible_activist_id) {
           const activistRes = await api.get(`/activists/${institutionData.responsible_activist_id}`);

            responsibleInfo = {
              type: 'activist',
              data: activistRes.data.data,
              title: 'ناشط مسؤول'
            };
          }
          break;

        case 'new_person':
        default:
          responsibleInfo = {
            type: 'new_person',
            data: {
              full_name: institutionData.representative_name,
              profile_image: institutionData.representative_profile_image,
              gender: institutionData.representative_gender,
              id_number: institutionData.representative_id_number,
              birth_date: institutionData.representative_birthdate,
              political_orientation: institutionData.representative_political_orientation,
            },
            title: 'مسؤول المؤسسة'
          };
          break;
      }

      setResponsibleData(responsibleInfo);
    } catch (error) {
      console.error('فشل في جلب بيانات المسؤول:', error);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      // جلب بيانات الارتباطات عند فتح التاب
      if (tab === '3') {
        fetchLinkedData();
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // 🆕 دالة جلب الصحفيين والناشطين المرتبطين
  const fetchLinkedData = async () => {
    if (!institution) return;
    
    setLinkedDataLoading(true);
    try {
      // جلب الصحفيين المرتبطين
      const journalistsRes = await api.get(`/institutions/${id}/journalists`);
      setLinkedJournalists(journalistsRes.data || []);

      // جلب الناشطين المرتبطين
      const activistsRes = await api.get(`/institutions/${id}/activists`);
      setLinkedActivists(activistsRes.data || []);

      // 🔗 جلب المؤسسات الأخرى المرتبطة (مخزّنة مباشرة بحقل linked_institutions)
      if (institution.linked_institutions) {
        try {
          const peerIds = (Array.isArray(institution.linked_institutions)
            ? institution.linked_institutions
            : JSON.parse(institution.linked_institutions || '[]')
          ).filter(pid => pid != institution.id);

          const peerPromises = peerIds.map(pid =>
            api.get(`/institutions/${pid}`).catch(e => {
              console.error(`فشل في جلب المؤسسة ${pid}:`, e);
              return null;
            })
          );
          const peerResponses = await Promise.all(peerPromises);
          setLinkedInstitutionPeers(
            peerResponses.filter(res => res !== null).map(res => res.data.data)
          );
        } catch (e) {
          console.error("فشل في جلب المؤسسات المرتبطة:", e);
        }
      }
    } catch (error) {
      console.error('خطأ في جلب بيانات الارتباطات:', error);
    } finally {
      setLinkedDataLoading(false);
    }
  };

  const getSocialMediaInfo = (url) => {
    if (!url) return { icon: 'fas fa-link', name: 'رابط', color: 'secondary' };
    
    const urlLower = url.toLowerCase();
    
    if (urlLower.includes('facebook.com') || urlLower.includes('fb.com')) {
      return { icon: 'fab fa-facebook', name: 'فيسبوك', color: 'primary' };
    } else if (urlLower.includes('twitter.com') || urlLower.includes('x.com')) {
      return { icon: 'fab fa-twitter', name: 'تويتر', color: 'info' };
    } else if (urlLower.includes('instagram.com')) {
      return { icon: 'fab fa-instagram', name: 'إنستغرام', color: 'danger' };
    } else if (urlLower.includes('linkedin.com')) {
      return { icon: 'fab fa-linkedin', name: 'لينكد إن', color: 'primary' };
    } else if (urlLower.includes('youtube.com') || urlLower.includes('youtu.be')) {
      return { icon: 'fab fa-youtube', name: 'يوتيوب', color: 'danger' };
    } else if (urlLower.includes('telegram.org') || urlLower.includes('t.me')) {
      return { icon: 'fab fa-telegram', name: 'تيليغرام', color: 'info' };
    } else if (urlLower.includes('whatsapp.com') || urlLower.includes('wa.me')) {
      return { icon: 'fab fa-whatsapp', name: 'واتساب', color: 'success' };
    } else if (urlLower.includes('tiktok.com')) {
      return { icon: 'fab fa-tiktok', name: 'تيك توك', color: 'dark' };
    } else {
      return { icon: 'fas fa-globe', name: 'موقع', color: 'secondary' };
    }
  };

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
    setImageZoomed(false);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setImageZoomed(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
    setImageZoomed(false);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    setImageZoomed(false);
  };

  const toggleZoom = () => {
    setImageZoomed(!imageZoomed);
  };

  const downloadImage = () => {
    const link = document.createElement('a');
    link.href = `${FILE_BASE_URL}/uploads/images/${images[currentImageIndex]}`;
    link.download = images[currentImageIndex];
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getYouTubeVideoId = (url) => {
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const getFileIcon = (filename) => {
    const extension = filename.toLowerCase().split('.').pop();
    switch (extension) {
      case 'pdf':
        return { icon: 'fas fa-file-pdf', color: '#dc3545' };
      case 'doc':
      case 'docx':
        return { icon: 'fas fa-file-word', color: '#2b579a' };
      case 'xls':
      case 'xlsx':
        return { icon: 'fas fa-file-excel', color: '#217346' };
      case 'ppt':
      case 'pptx':
        return { icon: 'fas fa-file-powerpoint', color: '#d24726' };
      case 'txt':
        return { icon: 'fas fa-file-alt', color: '#6c757d' };
      case 'zip':
      case 'rar':
        return { icon: 'fas fa-file-archive', color: '#fd7e14' };
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return { icon: 'fas fa-file-image', color: '#20c997' };
      default:
        return { icon: 'fas fa-file', color: '#6c757d' };
    }
  };

  const parseArrayField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch {
      return [];
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      'مرخص': 'success',
      'غير مرخص': 'warning',
      'محلي': 'info',
      'خارجية': 'primary',
      'مؤيد': 'success',
      'معارض': 'danger',
      'محايد': 'secondary'
    };
    return <Badge color={colors[status] || 'secondary'}>{status}</Badge>;
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner color="primary" size="lg" />
        <p className="mt-2">جاري تحميل بيانات المؤسسة...</p>
      </div>
    );
  }

  if (!institution) {
    return (
      <Card>
        <CardBody className="text-center">
          <h4>لم يتم العثور على المؤسسة</h4>
          <Link to="/dashboard/institutions">
            <Button color="primary">العودة إلى قائمة المؤسسات</Button>
          </Link>
        </CardBody>
      </Card>
    );
  }

  return (
    <div>
      {/* تطبيق الأنماط المخصصة */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .profile-header-card {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border: none;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
          }

          .profile-header-card .card-body {
            padding: 2rem;
          }

          .profile-header-card h2 {
            color: white !important;
            font-weight: bold;
            text-shadow: 0 2px 4px rgba(0,0,0,0.3);
          }

          .profile-header-card .profile-info-quick p {
            color: rgba(255, 255, 255, 0.9);
            font-size: 1.1rem;
          }

          .profile-header-card .profile-info-quick i {
            color: #ffd700 !important;
          }

          .info-card {
            border: none;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .info-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          }

          .info-card .card-title {
            border-bottom: 2px solid #e3f2fd;
            padding-bottom: 10px;
            margin-bottom: 20px;
            font-weight: bold;
          }

          .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;
            border-bottom: 1px solid #f8f9fa;
          }

          .info-item:last-child {
            border-bottom: none;
          }

          .info-item strong {
            color: #495057;
            font-weight: 600;
            flex: 0 0 40%;
          }

          .info-item span {
            color: #6c757d;
            flex: 1;
            text-align: left;
          }

          .badge-lg {
            font-size: 0.9rem;
            padding: 0.5rem 1rem;
          }

          .status-card {
            transition: all 0.3s ease;
            border: 1px solid transparent;
          }

          .status-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-color: #dee2e6;
          }

          .bg-gradient-primary {
            background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
          }

          .lightbox-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }

          .lightbox-content {
            position: relative;
            max-width: 90%;
            max-height: 90%;
          }

          .lightbox-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
            cursor: pointer;
          }

          .lightbox-image.zoomed {
            transform: scale(1.5);
            cursor: grab;
          }

          .lightbox-image.zoomed:active {
            cursor: grabbing;
          }

          .lightbox-controls {
            position: absolute;
            top: -60px;
            left: 0;
            display: flex;
            gap: 10px;
          }

          .lightbox-control-btn {
            background: rgba(255, 255, 255, 0.9);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 1rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background 0.3s ease;
          }

          .lightbox-control-btn:hover {
            background: rgba(255, 255, 255, 1);
          }

          .lightbox-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 255, 255, 0.8);
            border: none;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            font-size: 1.5rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .lightbox-nav:hover {
            background: rgba(255, 255, 255, 1);
          }

          .lightbox-prev {
            left: -70px;
          }

          .lightbox-next {
            right: -70px;
          }

          .lightbox-close {
            position: absolute;
            top: -50px;
            right: 0;
            background: rgba(255, 255, 255, 0.8);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 1.2rem;
            cursor: pointer;
          }

          .lightbox-close:hover {
            background: rgba(255, 255, 255, 1);
          }

          /* Enhanced Professional Lightbox */
          .custom-lightbox-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.95);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            animation: fadeIn 0.3s ease;
            padding: 20px;
          }

          .custom-lightbox-container {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            max-width: 95vw;
            max-height: 95vh;
          }

          .custom-lightbox-main-area {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            width: 100%;
            margin-bottom: 20px;
          }

          .custom-lightbox-image {
            max-width: 75vw;
            max-height: 70vh;
            object-fit: contain;
            border-radius: 12px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease;
            cursor: zoom-in;
          }

          .custom-lightbox-image.zoomed {
            transform: scale(2);
            cursor: zoom-out;
          }

          .custom-lightbox-close {
            position: absolute;
            top: -25px;
            right: -25px;
            background: rgba(255, 255, 255, 0.95);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            color: #333;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            z-index: 10001;
            backdrop-filter: blur(15px);
            font-size: 18px;
            font-weight: bold;
          }

          .custom-lightbox-close:hover {
            background: rgba(220, 53, 69, 0.95);
            color: white;
            transform: scale(1.1);
            box-shadow: 0 5px 20px rgba(220, 53, 69, 0.4);
          }

          .custom-lightbox-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 255, 255, 0.95);
            border: none;
            border-radius: 50%;
            width: 45px;
            height: 45px;
            color: #333;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            backdrop-filter: blur(15px);
            font-size: 16px;
            z-index: 10000;
          }

          .custom-lightbox-nav:hover {
            background: rgba(255, 255, 255, 1);
            transform: translateY(-50%) scale(1.1);
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
          }

          .custom-lightbox-nav:disabled {
            opacity: 0.4;
            cursor: not-allowed;
          }

          .custom-lightbox-nav:disabled:hover {
            transform: translateY(-50%) scale(1);
            box-shadow: none;
          }

          .custom-lightbox-prev {
            left: -35px;
          }

          .custom-lightbox-next {
            right: -35px;
          }

          .custom-lightbox-controls {
            background: rgba(0, 0, 0, 0.85);
            padding: 18px 30px;
            border-radius: 50px;
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            display: flex;
            gap: 20px;
            align-items: center;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
          }

          .custom-lightbox-btn {
            background: rgba(255, 255, 255, 0.15);
            border: none;
            border-radius: 12px;
            width: 50px;
            height: 50px;
            color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            font-size: 18px;
          }

          .custom-lightbox-btn:hover {
            background: rgba(255, 255, 255, 0.25);
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(255, 255, 255, 0.2);
          }

          .custom-lightbox-counter {
            color: white;
            font-size: 18px;
            font-weight: 600;
            padding: 0 20px;
            white-space: nowrap;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 25px;
            padding: 12px 20px;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.9); }
            to { opacity: 1; transform: scale(1); }
          }

          @media (max-width: 768px) {
            .custom-lightbox-overlay {
              padding: 20px;
            }
            
            .custom-lightbox-image {
              max-width: 80vw;
              max-height: 60vh;
            }
            
            .custom-lightbox-close {
              top: -20px;
              right: -20px;
              width: 35px;
              height: 35px;
              font-size: 16px;
            }
            
            .custom-lightbox-nav {
              width: 40px;
              height: 40px;
              font-size: 14px;
            }
            
            .custom-lightbox-prev {
              left: -30px;
            }
            
            .custom-lightbox-next {
              right: -30px;
            }
            
            .custom-lightbox-controls {
              padding: 15px 20px;
              gap: 15px;
            }
            
            .custom-lightbox-btn {
              width: 45px;
              height: 45px;
              font-size: 16px;
            }
            
            .custom-lightbox-counter {
              font-size: 16px;
              padding: 10px 15px;
            }
          }

          @media (max-width: 480px) {
            .custom-lightbox-overlay {
              padding: 25px;
            }
            
            .custom-lightbox-image {
              max-width: 85vw;
              max-height: 55vh;
            }
            
            .custom-lightbox-close {
              top: -15px;
              right: -15px;
              width: 32px;
              height: 32px;
              font-size: 14px;
            }
            
            .custom-lightbox-prev {
              left: -25px;
            }
            
            .custom-lightbox-next {
              right: -25px;
            }
          }

          .video-thumbnail {
            position: relative;
            cursor: pointer;
            border-radius: 8px;
            overflow: hidden;
            background: #000;
          }

          .video-thumbnail img {
            transition: transform 0.3s ease;
          }

          .video-thumbnail:hover img {
            transform: scale(1.05);
          }

          .video-play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(255, 0, 0, 0.8);
            color: white;
            border: none;
            border-radius: 50%;
            width: 60px;
            height: 60px;
            font-size: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          /* Enhanced Video Card Styles */
          .video-card {
            transition: all 0.3s ease;
            border-radius: 12px !important;
            overflow: hidden;
          }

          .video-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
          }

          .video-thumbnail-container {
            position: relative;
            border-radius: 8px 8px 0 0;
          }

          .video-thumbnail-img {
            transition: all 0.3s ease;
          }

          .video-card:hover .video-thumbnail-img {
            transform: scale(1.05);
          }

          .video-overlay {
            background: rgba(0, 0, 0, 0.1);
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .video-card:hover .video-overlay {
            opacity: 1;
          }

          .video-badge {
            font-size: 0.75rem;
            padding: 0.4rem 0.8rem;
          }

          /* Enhanced Attachment Card Styles */
          .attachment-card {
            transition: all 0.3s ease;
            border-radius: 12px !important;
            cursor: pointer;
          }

          .attachment-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
          }

          .file-icon-wrapper {
            transition: all 0.3s ease;
          }

          .attachment-card:hover .file-icon-wrapper {
            transform: scale(1.1);
          }

          .file-thumbnail {
            text-align: center;
            padding: 1rem;
            border: 1px solid #dee2e6;
            border-radius: 8px;
            transition: all 0.3s ease;
            cursor: pointer;
          }

          .file-thumbnail:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
          }

          .file-icon {
            font-size: 3rem;
            margin-bottom: 0.5rem;
          }

          .nav-tabs-custom .nav-link {
            border: none;
            border-radius: 25px;
            margin: 0 5px;
            transition: all 0.3s ease;
            font-weight: 500;
          }

         .nav-tabs-custom .nav-link:hover {
            background-color: #7a6fbe;
            color: #ffffff !important;
            transform: translateY(-2px);
          }

          .nav-tabs-custom .nav-link.active {
            background-color: #7a6fbe!important;
            color: #ffffff !important;
            box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
          }

          .description-content {
            background-color: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            border-left: 4px solid #007bff;
            line-height: 1.8;
          }

          .statement-card {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border: none;
            border-left: 4px solid #28a745;
            margin-bottom: 15px;
          }

          .statement-content {
            font-style: italic;
            line-height: 1.6;
            padding: 15px;
          }

          .image-item img:hover {
            transform: scale(1.05);
            transition: transform 0.3s ease;
          }

          .social-link-item, .video-link-item, .attachment-item {
            display: inline-block;
            margin-right: 10px;
            margin-bottom: 10px;
          }

          .map-placeholder {
            border: 2px dashed #dee2e6;
            transition: all 0.3s ease;
          }

          .map-placeholder:hover {
            border-color: #007bff;
            background-color: #f8f9fa !important;
          }

          .institution-logo {
            width: 120px;
            height: 120px;
            background: linear-gradient(135deg, #007bff, #0056b3);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 3rem;
            color: white;
            font-weight: bold;
            margin: 0 auto;
            box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
          }

          .responsible-card {
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            color: white;
            border: none;
            box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
          }

          .responsible-card h6 {
            color: white !important;
          }

          @media (max-width: 768px) {
            .profile-header-card .card-body {
              padding: 1rem;
            }
            
            .info-item {
              flex-direction: column;
              align-items: flex-start;
            }
            
            .info-item strong {
              margin-bottom: 5px;
            }
            
            .nav-tabs-custom {
              overflow-x: auto;
              white-space: nowrap;
            }
            
            .nav-tabs-custom .nav-item {
              display: inline-block;
            }
          }
        `
      }} />

      {/* Header Section - معلومات أساسية */}
      <Card className="profile-header-card mb-4">
        <CardBody>
          <Row className="align-items-center">
            <Col md={2} className="text-center">
              <div className="profile-image-container">
                {institution.logo ? (
                  <img
src={`${FILE_BASE_URL}/uploads/images/${institution.logo}`}
                    alt={institution.title}
                    className="img-fluid rounded"
                    style={{ 
                      width: "120px", 
                      height: "120px", 
                      objectFit: "cover",
                      border: "4px solid white",
                      borderRadius: "20px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
                    }}
                  />
                ) : (
                  <div className="institution-logo">
                    {institution.title?.charAt(0) || '؟'}
                  </div>
                )}
              </div>
            </Col>
            <Col md={7}>
              <h2 className="mb-3 text-primary">{institution.title}</h2>
              <div className="profile-info-quick">
                <p className="mb-2">
                  <i className="mdi mdi-certificate text-primary me-2"></i>
                  <strong>حالة الترخيص:</strong> {getStatusBadge(institution.license_status)}
                </p>
                <p className="mb-2">
                  <i className="mdi mdi-source-branch text-primary me-2"></i>
                  <strong>المرجعية:</strong> {getStatusBadge(institution.reference)}
                </p>
                <p className="mb-2">
                  <i className="mdi mdi-compass text-primary me-2"></i>
                  <strong>التوجه:</strong> {getStatusBadge(institution.orientation)}
                </p>
              </div>
            </Col>
            <Col md={3} className="text-end">
              <Link to={`/dashboard/institutions/edit/${institution.id}`}>
                <Button color="warning" size="lg" className="me-2">
                  <i className="mdi mdi-pencil me-1"></i>
                  تعديل
                </Button>
              </Link>
              <Link to="/dashboard/institutions">
                <Button color="secondary" size="lg">
                  <i className="mdi mdi-arrow-right me-1"></i>
                  عودة
                </Button>
              </Link>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* Navigation Tabs */}
      <Card>
        <CardBody>
          <Nav tabs className="nav-tabs-custom mb-4">
            <NavItem>
              <NavLink 
                className={classnames({ active: activeTab === '1' })} 
                onClick={() => toggleTab('1')}
                style={{ cursor: 'pointer' }}
              >
                <i className="mdi mdi-domain me-1"></i>
                معلومات المؤسسة
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                className={classnames({ active: activeTab === '2' })} 
                onClick={() => toggleTab('2')}
                style={{ cursor: 'pointer' }}
              >
                <i className="mdi mdi-account-tie me-1"></i>
                المسؤول
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                className={classnames({ active: activeTab === '3' })} 
                onClick={() => toggleTab('3')}
                style={{ cursor: 'pointer' }}
              >
                <i className="mdi mdi-account-group me-1"></i>
                الارتباطات
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink 
                className={classnames({ active: activeTab === '4' })} 
                onClick={() => toggleTab('4')}
                style={{ cursor: 'pointer' }}
              >
                <i className="mdi mdi-folder-multiple-image me-1"></i>
                المرفقات
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* Tab 1: معلومات المؤسسة */}
            <TabPane tabId="1">
              {/* الصف الأول: البيانات الأساسية + العنوان + شعار المؤسسة */}
              <Row className="mb-4">
                <Col md={4}>
                  <Card className="info-card h-100">
                    <CardBody>
                      <h5 className="card-title text-primary mb-4">
                        <i className="mdi mdi-domain me-2"></i>
                        البيانات الأساسية
                      </h5>
                      
                      {/* اسم المؤسسة */}
                      <div className="info-item">
                        <strong>اسم المؤسسة:</strong>
                        <span className="fs-6 fw-bold text-dark">{institution.title}</span>
                      </div>

                      {/* الحالات المهمة */}
                      <div className="mt-3">
                        <div className="info-item">
                          <strong>حالة الترخيص:</strong>
                          <div className="mt-2">
                            <span>{institution.license_status || 'غير محدد'}</span>
                          </div>
                        </div>
                        <div className="info-item">
                          <strong>المرجعية:</strong>
                          <div className="mt-2">
                            <span>{institution.reference || 'غير محدد'}</span>
                          </div>
                        </div>
                        <div className="info-item">
                          <strong>التوجه السياسي:</strong>
                          <div className="mt-2">
                            <span>{institution.orientation || 'غير محدد'}</span>
                          </div>
                        </div>
                      </div>

                      {/* معلومات إضافية */}
                      <div className="mt-3">
                        <div className="info-item">
                          <strong>تاريخ الإنشاء:</strong>
                          <span dir="ltr">{formatDate(institution.created_at)}</span>
                        </div>
                        <div className="info-item">
                          <strong>آخر تحديث:</strong>
                          <span dir="ltr">{formatDate(institution.updated_at)}</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="info-card h-100">
                    <CardBody>
                      <h5 className="card-title text-primary mb-4">
                        <i className="mdi mdi-map-marker me-2"></i>
                        العنوان
                      </h5>
                      <div className="info-item">
                        <strong>الدولة:</strong>
                        <span>{institution.country || 'فلسطين'}</span>
                      </div>
                      <div className="info-item">
                        <strong>المحافظة:</strong>
                        <span>{institution.country_province || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>المدينة/المنطقة:</strong>
                        <span>{institution.city_or_area || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>تفاصيل العنوان:</strong>
                        <span>{institution.address_details || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>العنوان على الخريطة:</strong>
                        <div className="mt-1">
                          {institution.map_address ? (
                            <a 
                              href={`https://www.google.com/maps?q=${institution.map_address}`}
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              <i className="mdi mdi-map me-1"></i>
                              عرض على خرائط جوجل
                            </a>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className="info-card h-100">
                    <CardBody className="text-center">
                      <h5 className="card-title text-primary mb-4">
                        <i className="mdi mdi-image me-2"></i>
                        شعار المؤسسة
                      </h5>
                      <div className="mt-3">
                        {institution.logo ? (
                          <img
                            src={`${FILE_BASE_URL}/uploads/images/${institution.logo}`}
                            alt="لوجو المؤسسة"
                            className="img-fluid rounded shadow"
                            style={{ 
                              maxWidth: "350px", 
                              maxHeight: "350px", 
                              objectFit: "cover",
                              border: "2px solid #e9ecef",
                              cursor: "pointer"
                            }}
                            onClick={() => window.open(`${FILE_BASE_URL}/uploads/images/${institution.logo}`, '_blank')}
                          />
                        ) : (
                          <div className="institution-logo mb-3" style={{ width: "280px", height: "280px" }}>
                            {institution.title?.charAt(0) || '؟'}
                          </div>
                        )}
                        <h6 className="text-muted mt-3">شعار المؤسسة الرسمي</h6>
                        {institution.logo && (
                          <small className="text-muted">انقر للعرض بالحجم الكامل</small>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* الصف الثاني: معلومات الاتصال + حسابات التواصل الاجتماعي */}
              <Row className="mb-4">
                <Col md={6}>
                  <Card className="info-card h-100">
                    <CardBody>
                      <h5 className="card-title text-primary mb-4">
                        <i className="mdi mdi-phone me-2"></i>
                        معلومات الاتصال
                      </h5>
                      <div className="info-item">
                        <strong>واتساب 1:</strong>
                        <span dir="ltr">{institution.whatsapp1 || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>تلفون/فاكس:</strong>
                        <span dir="ltr">{institution.phone_fax || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>جوال 1:</strong>
                        <span dir="ltr">{institution.mobile1 || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>أوريدو:</strong>
                        <span dir="ltr">{institution.oreedo_number || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>البريد الإلكتروني:</strong>
                        <span className="small" dir="ltr">{institution.email || '-'}</span>
                      </div>
                      <div className="info-item">
                        <strong>الموقع الإلكتروني:</strong>
                        <span className="small">
                          {institution.website ? (
                            <a href={institution.website} target="_blank" rel="noopener noreferrer" dir="ltr">
                              {institution.website}
                            </a>
                          ) : '-'}
                        </span>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card className="info-card h-100">
                    <CardBody>
                      <h5 className="card-title text-primary mb-4">
                        <i className="mdi mdi-share-variant me-2"></i>
                        حسابات التواصل الاجتماعي
                      </h5>
                      {parseArrayField(institution.social_accounts).length > 0 ? (
                        <div className="social-accounts-grid">
                          {parseArrayField(institution.social_accounts).map((account, index) => {
                            const socialInfo = getSocialMediaInfo(account);
                            return (
                              <div key={index} className="social-account-item mb-3">
                                <div className="d-flex align-items-center p-2 bg-light rounded border">
                                  <div className="me-3">
                                    <i 
                                      className={`${socialInfo.icon} text-${socialInfo.color}`}
                                      style={{ fontSize: '1.3rem' }}
                                    ></i>
                                  </div>
                                  <div className="flex-grow-1">
                                    <small className="text-muted d-block mb-1">{socialInfo.name}</small>
                                    <a 
                                      href={account} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      className="text-decoration-none small text-truncate d-block"
                                      title={account}
                                    >
                                      {account.replace(/^https?:\/\//, '')}
                                    </a>
                                  </div>
                                  <div className="ms-2">
                                    <a 
                                      href={account} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-outline-primary"
                                    >
                                      <i className="fas fa-external-link-alt"></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="text-center text-muted py-4">
                          <i className="fas fa-share-alt" style={{ fontSize: '2rem' }}></i>
                          <p className="mt-2 mb-0">لا توجد حسابات تواصل اجتماعي</p>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* الصف الثالث: نبذة عن المؤسسة */}
              {institution.description && (
                <Row className="mb-4">
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-primary mb-4">
                          <i className="mdi mdi-text-long me-2"></i>
                          نبذة عن المؤسسة
                        </h5>
                        <div 
                          className="description-content"
                          dangerouslySetInnerHTML={{ __html: institution.description }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* الصف الرابع: إحصائيات سريعة */}
              <Row>
                <Col md={12}>
                  <Card className="info-card bg-gradient-primary text-white">
                    <CardBody>
                      <h5 className="card-title text-white mb-3">
                        <i className="mdi mdi-chart-line me-2"></i>
                        ملخص سريع
                      </h5>
                      <Row className="text-center">
                        <Col md={3}>
                          <div className="mb-2">
                            <h4 className="text-white mb-1">{images.length}</h4>
                            <small className="text-white-50">صورة مرفقة</small>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-2">
                            <h4 className="text-white mb-1">{parseArrayField(institution.social_accounts).length}</h4>
                            <small className="text-white-50">حساب اجتماعي</small>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-2">
                            <h4 className="text-white mb-1">{parseArrayField(institution.attachments).length}</h4>
                            <small className="text-white-50">ملف مرفق</small>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-2">
                            <h4 className="text-white mb-1">{parseArrayField(institution.youtube_links).length}</h4>
                            <small className="text-white-50">فيديو</small>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>

            {/* Tab 2: المسؤول */}
            <TabPane tabId="2">
              {responsibleData ? (
                <>
                  {/* كارت بيانات المسؤول */}
                  <Row className="mb-4">
                    <Col md={12}>
                      <Card className="responsible-card">
                        <CardBody>
                          <Row className="align-items-center">
                            <Col md={2} className="text-center">
                              {responsibleData.data?.profile_image ? (
                                <img
src={`${FILE_BASE_URL}/uploads/images/${responsibleData.data.profile_image}`}
                                  alt={responsibleData.data.full_name}
                                  className="rounded-circle img-fluid"
                                  style={{ 
                                    width: "100px", 
                                    height: "100px", 
                                    objectFit: "cover",
                                    border: "3px solid white"
                                  }}
                                />
                              ) : (
                                <div 
                                  className="rounded-circle bg-white d-flex align-items-center justify-content-center text-success"
                                  style={{ width: "100px", height: "100px", fontSize: "36px", fontWeight: "bold" }}
                                >
                                  {responsibleData.data?.full_name?.charAt(0) || '؟'}
                                </div>
                              )}
                            </Col>
                            <Col md={8}>
                              <h4 className="text-white mb-2">{responsibleData.data?.full_name || 'غير محدد'}</h4>
                              <h6 className="text-white-50 mb-3">{responsibleData.title}</h6>
                              <div className="d-flex flex-wrap gap-2">
                                <Badge color="light" className="text-success" style={{ fontSize: '0.9rem', padding: '0.5rem 0.8rem' }}>
                                  {responsibleData.type === 'journalist' ? 'صحفي موجود' : 
                                   responsibleData.type === 'activist' ? 'ناشط موجود' : 'شخص جديد'}
                                </Badge>
                                {responsibleData.data?.gender && (
                                  <Badge color="light" className="text-success" style={{ fontSize: '0.9rem', padding: '0.5rem 0.8rem' }}>{responsibleData.data.gender}</Badge>
                                )}
                              </div>
                            </Col>
                            <Col md={2} className="text-end">
                              {(responsibleData.type === 'journalist' || responsibleData.type === 'activist') && (
                                <Link 
                                  to={`/dashboard/${responsibleData.type === 'journalist' ? 'journalists' : 'activists'}/view/${responsibleData.data.id}`}
                                  target="_blank"
                                >
                                  <Button color="light" size="sm">
                                    <i className="mdi mdi-eye me-1"></i>
                                    عرض البروفايل
                                  </Button>
                                </Link>
                              )}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* تفاصيل المسؤول */}
                  <Row>
                    <Col md={6}>
                      <Card className="info-card h-100">
                        <CardBody>
                          <h5 className="card-title text-primary mb-3">
                            <i className="mdi mdi-account-details me-2"></i>
                            البيانات الأساسية
                          </h5>
                          <div className="info-item">
                            <strong>الاسم:</strong>
                            <span>{responsibleData.data?.full_name || '-'}</span>
                          </div>
                          <div className="info-item">
                            <strong>الجنس:</strong>
                            <span>{responsibleData.data?.gender || '-'}</span>
                          </div>
                          {responsibleData.data?.id_number && (
                            <div className="info-item">
                              <strong>رقم الهوية:</strong>
                              <span>{responsibleData.data.id_number}</span>
                            </div>
                          )}
                          <div className="info-item">
                            <strong>تاريخ الميلاد:</strong>
                            <span>{formatDate(responsibleData.data?.birth_date)}</span>
                          </div>
                          {responsibleData.type !== 'new_person' && (
                            <div className="info-item">
                              <strong>المهنة:</strong>
                              <span>{responsibleData.type === 'journalist' ? 'صحفي' : 'ناشط'}</span>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md={6}>
                      <Card className="info-card h-100">
                        <CardBody>
                          <h5 className="card-title text-primary mb-3">
                            <i className="mdi mdi-flag me-2"></i>
                            الميول السياسية
                          </h5>
                          <div className="d-flex flex-wrap gap-2">
                            {parseArrayField(responsibleData.data?.political_orientation).length > 0 ? (
                              parseArrayField(responsibleData.data.political_orientation).map((orientation, index) => (
                                <Badge key={index} color="primary" pill className="badge-lg">
                                  {orientation}
                                </Badge>
                              ))
                            ) : (
                              <span className="text-muted">لا توجد ميول سياسية محددة</span>
                            )}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* أقوال وتصريحات المسؤول */}
                  {parseArrayField(institution.representative_statements).length > 0 && (
                    <Row className="mt-4">
                      <Col md={12}>
                        <Card className="info-card">
                          <CardBody>
                            <h5 className="card-title text-primary mb-3">
                              <i className="mdi mdi-comment-quote me-2"></i>
                              أقوال وتصريحات المسؤول
                            </h5>
                            <div className="statements-container">
                              {parseArrayField(institution.representative_statements).map((statement, index) => (
                                <Card key={index} className="statement-card">
                                  <CardBody>
                                    <p className="statement-content mb-0">
                                      <i className="mdi mdi-format-quote-open me-2"></i>
                                      {statement}
                                      <i className="mdi mdi-format-quote-close ms-2"></i>
                                    </p>
                                  </CardBody>
                                </Card>
                              ))}
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                <Card className="info-card">
                  <CardBody className="text-center">
                    <i className="mdi mdi-account-off text-muted" style={{ fontSize: "48px" }}></i>
                    <h5 className="text-muted mt-3">لا يوجد مسؤول محدد</h5>
                    <p className="text-muted">لم يتم تحديد مسؤول لهذه المؤسسة</p>
                  </CardBody>
                </Card>
              )}
            </TabPane>

            {/* Tab 3: الارتباطات */}
            <TabPane tabId="3">
              {linkedDataLoading ? (
                <div className="text-center py-5">
                  <Spinner size="lg" color="primary" />
                  <p className="mt-2">جارٍ تحميل بيانات الارتباطات...</p>
                </div>
              ) : (
                <Row>
                  {/* الصحفيين المرتبطين */}
                  <Col md={6} className="mb-4">
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-primary mb-3">
                          <i className="mdi mdi-account-tie me-2"></i>
                          الصحفيين المرتبطين ({linkedJournalists.length})
                        </h5>
                        {linkedJournalists.length > 0 ? (
                          <Row>
                            {linkedJournalists.map((journalist) => (
                              <Col md={12} key={journalist.id} className="mb-3">
                                <Card className="border">
                                  <CardBody className="p-3">
                                    <div className="d-flex align-items-center">
                                      <div className="me-3">
                                        {journalist.profile_image ? (
                                          <>
                                            <img
                                              src={`${FILE_BASE_URL}/uploads/images/${journalist.profile_image}`}
                                              alt={journalist.full_name}
                                              className="rounded-circle"
                                              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentNode.querySelector('.fallback-avatar').style.display = 'block';
                                              }}
                                            />
                                            <div className="fallback-avatar" style={{ display: 'none' }}>
                                              {getJournalistAvatarCircle(journalist.full_name, '50px', '16px')}
                                            </div>
                                          </>
                                        ) : (
                                          getJournalistAvatarCircle(journalist.full_name, '50px', '16px')
                                        )}
                                      </div>
                                      <div className="flex-grow-1">
                                        <h6 className="mb-1">{journalist.full_name}</h6>
                                        <small className="text-muted">{journalist.profession || 'صحفي'}</small>
                                      </div>
                                      <div>
                                        <Link to={`/dashboard/journalists/view/${journalist.id}`}>
                                          <Button color="outline-primary" size="sm">
                                            <i className="mdi mdi-eye me-1"></i>
                                            عرض
                                          </Button>
                                        </Link>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <div className="text-center py-4 text-muted">
                            <i className="mdi mdi-account-off mdi-48px mb-2"></i>
                            <p>لا يوجد صحفيين مرتبطين بهذه المؤسسة</p>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>

                  {/* الناشطين المرتبطين */}
                  <Col md={6} className="mb-4">
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-success mb-3">
                          <i className="mdi mdi-account-group me-2"></i>
                          الناشطين المرتبطين ({linkedActivists.length})
                        </h5>
                        {linkedActivists.length > 0 ? (
                          <Row>
                            {linkedActivists.map((activist) => (
                              <Col md={12} key={activist.id} className="mb-3">
                                <Card className="border">
                                  <CardBody className="p-3">
                                    <div className="d-flex align-items-center">
                                      <div className="me-3">
                                        {activist.profile_image ? (
                                          <>
                                            <img
                                              src={`${FILE_BASE_URL}/uploads/images/${activist.profile_image}`}
                                              alt={activist.full_name}
                                              className="rounded-circle"
                                              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentNode.querySelector('.fallback-avatar').style.display = 'block';
                                              }}
                                            />
                                            <div className="fallback-avatar" style={{ display: 'none' }}>
                                              {getActivistAvatarCircle(activist.full_name, '50px', '16px')}
                                            </div>
                                          </>
                                        ) : (
                                          getActivistAvatarCircle(activist.full_name, '50px', '16px')
                                        )}
                                      </div>
                                      <div className="flex-grow-1">
                                        <h6 className="mb-1">{activist.full_name}</h6>
                                        <small className="text-muted">ناشط</small>
                                      </div>
                                      <div>
                                        <Link to={`/dashboard/activists/view/${activist.id}`}>
                                          <Button color="outline-success" size="sm">
                                            <i className="mdi mdi-eye me-1"></i>
                                            عرض
                                          </Button>
                                        </Link>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <div className="text-center py-4 text-muted">
                            <i className="mdi mdi-account-multiple-minus mdi-48px mb-2"></i>
                            <p>لا يوجد ناشطين مرتبطين بهذه المؤسسة</p>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>

                  {/* 🔗 المؤسسات الأخرى المرتبطة */}
                  <Col md={6} className="mb-4">
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-info mb-3">
                          <i className="mdi mdi-sitemap me-2"></i>
                          المؤسسات المرتبطة ({linkedInstitutionPeers.length})
                        </h5>
                        {linkedInstitutionPeers.length > 0 ? (
                          <Row>
                            {linkedInstitutionPeers.map((peer) => (
                              <Col md={12} key={peer.id} className="mb-3">
                                <Card className="border">
                                  <CardBody className="p-3">
                                    <div className="d-flex align-items-center">
                                      <div className="me-3">
                                        {peer.logo ? (
                                          <>
                                            <img
                                              src={`${FILE_BASE_URL}/uploads/images/${peer.logo}`}
                                              alt={peer.title}
                                              className="rounded"
                                              style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.parentNode.querySelector('.fallback-avatar').style.display = 'block';
                                              }}
                                            />
                                            <div className="fallback-avatar" style={{ display: 'none' }}>
                                              {getInstitutionPeerAvatarCircle(peer.title, '50px', '16px')}
                                            </div>
                                          </>
                                        ) : (
                                          getInstitutionPeerAvatarCircle(peer.title, '50px', '16px')
                                        )}
                                      </div>
                                      <div className="flex-grow-1">
                                        <h6 className="mb-1">{peer.title}</h6>
                                        <small className="text-muted">مؤسسة</small>
                                      </div>
                                      <div>
                                        <Link to={`/dashboard/institutions/view/${peer.id}`}>
                                          <Button color="outline-info" size="sm">
                                            <i className="mdi mdi-eye me-1"></i>
                                            عرض
                                          </Button>
                                        </Link>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <div className="text-center py-4 text-muted">
                            <i className="mdi mdi-sitemap mdi-48px mb-2"></i>
                            <p>لا يوجد مؤسسات أخرى مرتبطة بهذه المؤسسة</p>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </TabPane>

            {/* Tab 4: المرفقات */}
            <TabPane tabId="4">
              {/* الصور */}
              {images.length > 0 && (
                <Row className="mb-4">
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-primary mb-3">
                          <i className="mdi mdi-image-multiple me-2"></i>
                          الصور ({images.length})
                        </h5>
                        <Row>
                          {images.map((image, index) => (
                            <Col key={index} md={3} className="mb-3">
                              <div className="image-item">
                                <img
                                  src={`${FILE_BASE_URL}/uploads/images/${image}`}
                                  alt={`صورة ${index + 1}`}
                                  className="img-fluid rounded shadow-sm"
                                  style={{ 
                                    height: "150px", 
                                    width: "100%", 
                                    objectFit: "cover",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => openLightbox(index)}
                                />
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* مقاطع الفيديو */}
              {parseArrayField(institution.youtube_links).length > 0 ? (
                <Row className="mb-4">
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-primary mb-4">
                          <i className="fab fa-youtube me-2"></i>
                          مقاطع اليوتيوب ({parseArrayField(institution.youtube_links).length})
                        </h5>
                        <Row>
                          {parseArrayField(institution.youtube_links).map((video, index) => {
                            const videoId = getYouTubeVideoId(video);
                            const thumbnailUrl = videoId 
                              ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` 
                              : `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                            
                            return (
                              <Col key={index} lg={4} md={6} className="mb-4">
                                <Card className="video-card h-100 border-0 shadow-sm">
                                  <div className="video-thumbnail-container position-relative overflow-hidden">
                                    {thumbnailUrl ? (
                                      <>
                                        <img
                                          src={thumbnailUrl}
                                          alt={`فيديو يوتيوب ${index + 1}`}
                                          className="video-thumbnail-img"
                                          style={{ 
                                            width: '100%', 
                                            height: '200px', 
                                            objectFit: 'cover',
                                            borderRadius: '8px 8px 0 0'
                                          }}
                                        />
                                        <div className="video-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                                          <div 
                                            className="video-play-button bg-danger text-white rounded-circle d-flex align-items-center justify-content-center shadow-lg"
                                            style={{ 
                                              width: '60px', 
                                              height: '60px', 
                                              fontSize: '1.5rem',
                                              cursor: 'pointer',
                                              transition: 'all 0.3s ease'
                                            }}
                                            onClick={() => window.open(video, '_blank')}
                                            onMouseEnter={(e) => {
                                              e.target.style.transform = 'scale(1.1)';
                                              e.target.style.backgroundColor = '#c82333';
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.transform = 'scale(1)';
                                              e.target.style.backgroundColor = '#dc3545';
                                            }}
                                          >
                                            <i className="fab fa-youtube"></i>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <div 
                                        className="video-placeholder d-flex align-items-center justify-content-center bg-light border"
                                        style={{ height: '200px', borderRadius: '8px 8px 0 0' }}
                                      >
                                        <div className="text-center">
                                          <i className="fab fa-youtube text-danger" style={{ fontSize: '3rem' }}></i>
                                          <p className="mt-3 text-muted mb-0">فيديو يوتيوب</p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <CardBody className="p-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <h6 className="video-title mb-2 text-dark">
                                        <i className="fab fa-youtube text-danger me-2"></i>
                                        فيديو يوتيوب {index + 1}
                                      </h6>
                                      <Badge color="danger" pill className="video-badge">
                                        <i className="fab fa-youtube me-1"></i>
                                        YouTube
                                      </Badge>
                                    </div>
                                    <div className="video-actions mt-3">
                                      <Button 
                                        color="danger" 
                                        size="sm" 
                                        className="me-2"
                                        onClick={() => window.open(video, '_blank')}
                                      >
                                        <i className="fas fa-play me-1"></i>
                                        مشاهدة
                                      </Button>
                                      <Button 
                                        color="outline-secondary" 
                                        size="sm"
                                        onClick={() => {
                                          navigator.clipboard.writeText(video);
                                          // يمكنك إضافة إشعار هنا
                                        }}
                                      >
                                        <i className="fas fa-copy me-1"></i>
                                        نسخ الرابط
                                      </Button>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                          })}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                <Row className="mb-4">
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody className="text-center py-5">
                        <i className="fab fa-youtube text-muted" style={{ fontSize: "48px" }}></i>
                        <h5 className="text-muted mt-3">لا توجد مقاطع فيديو</h5>
                        <p className="text-muted">لم يتم إضافة أي مقاطع فيديو يوتيوب لهذه المؤسسة</p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* ملفات الفيديو المرفوعة */}
              {parseArrayField(institution.video_files).length > 0 ? (
                <Row className="mb-4">
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title mb-4" style={{ color: '#6f42c1' }}>
                          <i className="fas fa-video me-2"></i>
                          ملفات الفيديو ({parseArrayField(institution.video_files).length})
                        </h5>
                        <Row>
                          {parseArrayField(institution.video_files).map((videoFile, index) => {
                            const fileName = videoFile.split('/').pop() || videoFile;
                            const truncatedName = fileName.length > 30 ? fileName.substring(0, 30) + '...' : fileName;

                            return (
                              <Col key={index} lg={6} md={12} className="mb-4">
                                <Card className="video-card h-100 border-0 shadow-sm">
                                  <CardBody className="p-3">
                                    <div className="video-container mb-3" style={{ backgroundColor: '#000', borderRadius: '8px', overflow: 'hidden' }}>
                                      <video controls className="w-100" style={{ maxHeight: '300px' }} preload="metadata">
                                        <source
                                          src={`${FILE_BASE_URL}/uploads/videos/${videoFile}`}
                                          type={`video/${videoFile.split('.').pop()?.toLowerCase() || 'mp4'}`}
                                        />
                                        متصفحك لا يدعم تشغيل الفيديو
                                      </video>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <i className="fas fa-video me-2" style={{ color: '#6f42c1' }}></i>
                                        <span className="text-dark fw-medium" title={fileName}>{truncatedName}</span>
                                      </div>
                                      <Button
                                        color="primary"
                                        size="sm"
                                        onClick={() => {
                                          const link = document.createElement('a');
                                          link.href = `${FILE_BASE_URL}/uploads/videos/${videoFile}`;
                                          link.download = fileName;
                                          link.click();
                                        }}
                                      >
                                        <i className="fas fa-download me-1"></i>
                                        تحميل
                                      </Button>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                          })}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody className="text-center py-5">
                        <i className="fas fa-video text-muted" style={{ fontSize: "48px" }}></i>
                        <h5 className="text-muted mt-3">لا توجد ملفات فيديو</h5>
                        <p className="text-muted">لم يتم رفع أي ملفات فيديو لهذه المؤسسة</p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* المرفقات الأخرى */}
              {parseArrayField(institution.attachments).length > 0 ? (
                <Row>
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody>
                        <h5 className="card-title text-primary mb-4">
                          <i className="fas fa-paperclip me-2"></i>
                          المرفقات الأخرى ({parseArrayField(institution.attachments).length})
                        </h5>
                        <Row>
                          {parseArrayField(institution.attachments).map((attachment, index) => {
                            const fileInfo = getFileIcon(attachment);
                            const fileName = attachment.split('/').pop() || attachment;
                            const fileExtension = fileName.split('.').pop()?.toUpperCase() || 'FILE';
                            const truncatedName = fileName.length > 25 ? fileName.substring(0, 25) + '...' : fileName;
                            
                            return (
                              <Col key={index} lg={3} md={4} sm={6} className="mb-4">
                                <Card className="attachment-card h-100 border-0 shadow-sm">
                                  <CardBody className="text-center p-4">
                                    <div className="file-icon-container mb-3">
                                      <div 
                                        className="file-icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle shadow-sm"
                                        style={{ 
                                          width: '80px', 
                                          height: '80px', 
                                          backgroundColor: `${fileInfo.color}15`,
                                          border: `2px solid ${fileInfo.color}30`
                                        }}
                                      >
                                        <i 
                                          className={fileInfo.icon}
                                          style={{ 
                                            fontSize: '2.5rem', 
                                            color: fileInfo.color 
                                          }}
                                        ></i>
                                      </div>
                                    </div>
                                    
                                    <h6 
                                      className="file-name mb-2 text-dark fw-bold"
                                      style={{ 
                                        fontSize: '0.9rem', 
                                        lineHeight: '1.3',
                                        minHeight: '2.6rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}
                                      title={fileName}
                                    >
                                      {truncatedName}
                                    </h6>
                                    
                                    <div className="file-info mb-3">
                                      <Badge 
                                        style={{ 
                                          backgroundColor: fileInfo.color,
                                          fontSize: '0.75rem',
                                          padding: '0.4rem 0.8rem'
                                        }}
                                        className="text-white mb-2"
                                      >
                                        {fileExtension}
                                      </Badge>
                                      <div className="file-size text-muted small">
                                        <i className="fas fa-weight-hanging me-1"></i>
                                        {(() => {
                                          const fileSize = Math.floor(Math.random() * 5000) + 100;
                                          return fileSize > 1024 ? `${(fileSize / 1024).toFixed(1)} MB` : `${fileSize} KB`;
                                        })()}
                                      </div>
                                    </div>
                                    
                                    <div className="file-actions d-flex gap-2 justify-content-center">
                                      <Button 
                                        color="primary" 
                                        size="sm"
                                        className="flex-fill"
                                        onClick={() => window.open(`${FILE_BASE_URL}/uploads/attachments/${attachment}`, '_blank')}
                                        style={{ fontSize: '0.8rem' }}
                                      >
                                        <i className="fas fa-eye me-1"></i>
                                        عرض
                                      </Button>
                                      <Button 
                                        color="success" 
                                        size="sm"
                                        className="flex-fill"
                                        onClick={() => {
                                          const link = document.createElement('a');
                                          link.href = `${FILE_BASE_URL}/uploads/attachments/${attachment}`;
                                          link.download = fileName;
                                          link.click();
                                        }}
                                        style={{ fontSize: '0.8rem' }}
                                      >
                                        <i className="fas fa-download me-1"></i>
                                        تحميل
                                      </Button>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                          })}
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody className="text-center py-5">
                        <i className="fas fa-paperclip text-muted" style={{ fontSize: "48px" }}></i>
                        <h5 className="text-muted mt-3">لا توجد مرفقات أخرى</h5>
                        <p className="text-muted">لم يتم إضافة أي ملفات أو مستندات لهذه المؤسسة</p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* رسالة في حال عدم وجود مرفقات */}
              {images.length === 0 && 
               parseArrayField(institution.youtube_links).length === 0 && 
               parseArrayField(institution.video_files).length === 0 && 
               parseArrayField(institution.attachments).length === 0 && (
                <Row>
                  <Col md={12}>
                    <Card className="info-card">
                      <CardBody className="text-center">
                        <i className="mdi mdi-folder-open text-muted" style={{ fontSize: "48px" }}></i>
                        <h5 className="text-muted mt-3">لا توجد مرفقات</h5>
                        <p className="text-muted">لم يتم إضافة أي صور أو فيديوهات أو ملفات لهذه المؤسسة</p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>

      {/* Enhanced Professional Lightbox */}
      {lightboxOpen && images.length > 0 && (
        <div className="custom-lightbox-overlay" onClick={closeLightbox}>
          <div className="custom-lightbox-container" onClick={(e) => e.stopPropagation()}>
            
            <div className="custom-lightbox-main-area">
              {/* Close Button - Outside Image */}
              <button className="custom-lightbox-close" onClick={closeLightbox}>
                <i className="fas fa-times"></i>
              </button>
              
              {/* Large Image */}
              <img
                src={`${FILE_BASE_URL}/uploads/images/${images[currentImageIndex]}`}
                alt={`صورة ${currentImageIndex + 1}`}
                className={`custom-lightbox-image ${imageZoomed ? 'zoomed' : ''}`}
                onClick={toggleZoom}
              />
              
              {/* Navigation Arrows - Outside Image */}
              {images.length > 1 && (
                <>
                  <button className="custom-lightbox-nav custom-lightbox-prev" onClick={prevImage}>
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <button className="custom-lightbox-nav custom-lightbox-next" onClick={nextImage}>
                    <i className="fas fa-chevron-right"></i>
                  </button>
                </>
              )}
            </div>
            
            {/* Bottom Control Bar */}
            <div className="custom-lightbox-controls">
              <button className="custom-lightbox-btn" onClick={toggleZoom} title={imageZoomed ? "تصغير" : "تكبير"}>
                <i className={`fas ${imageZoomed ? 'fa-search-minus' : 'fa-search-plus'}`}></i>
              </button>
              <button className="custom-lightbox-btn" onClick={downloadImage} title="تحميل الصورة">
                <i className="fas fa-download"></i>
              </button>
              <span className="custom-lightbox-counter">
                {currentImageIndex + 1} من {images.length}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(ViewInstitution);